import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AuthService } from '../../api/services/auth.service';
import { AvatarService } from '../services/avatar.service';
import { NotificationService } from '../../api/services/notification.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class HeaderService {

  constructor(
    private authService: AuthService,
    private avatarService: AvatarService,
    private notificationService: NotificationService
  ) { }

  profileImageObserver = new Subject<string>();
  notificationsObserver = new Subject<string>();
  public tasksCount = new BehaviorSubject(false);
  public marketSelectedBool = new BehaviorSubject(false);

  getImageFromUserService() {
    this.avatarService.getAvatarByUserId(this.authService.getUserId())
      .subscribe(url => this.profileImageObserver.next(url || '/assets/images/avatar-profile-image.png'));
  }

  getProfileImage() {
    setTimeout(() => this.getImageFromUserService(), 0);

    return this.profileImageObserver;
  }

  refreshHeaderProfileImage() {
    this.getImageFromUserService();
  }

  getNotificationsAcknowledged() {
   this.notificationService.getCountOfUnacknowledgedWebNotification()
          .subscribe(notificationsCount => {
      this.notificationsObserver.next(notificationsCount.toString());
    });
  }

  getNotificationNumber() {
    setTimeout(() => this.getNotificationsAcknowledged(), 100);
    return this.notificationsObserver;
  }

  refreshNotificationsBadge() {
    this.getNotificationsAcknowledged();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/header/header.service.ts